export const categories = [
  {
    id: "drama",
    name: "剧集风云",
    desc: "剧集热播、口碑反转与排播动态",
    icon: "ri-movie-2-line",
    count: 26,
  },
  {
    id: "variety",
    name: "综艺观察",
    desc: "节目名场面、剪辑争议与赛制讨论",
    icon: "ri-live-line",
    count: 18,
  },
  {
    id: "movie",
    name: "电影快报",
    desc: "票房走势、档期竞争与主创动态",
    icon: "ri-film-line",
    count: 15,
  },
  {
    id: "music",
    name: "音乐现场",
    desc: "音乐节阵容、演唱会门票与现场体验",
    icon: "ri-music-2-line",
    count: 14,
  },
  {
    id: "fashion",
    name: "星光时尚",
    desc: "红毯造型、高定礼服与时尚风向",
    icon: "ri-vip-diamond-line",
    count: 11,
  },
  {
    id: "buzz",
    name: "全网热议",
    desc: "社交平台焦点话题与舆论走势",
    icon: "ri-fire-line",
    count: 22,
  },
];

export const events = [
  {
    id: 1,
    slug: "summer-drama-comeback",
    title: "暑期档黑马剧集口碑逆袭，长尾效应为何这么猛",
    category: "剧集风云",
    categoryId: "drama",
    summary:
      "开播首周排片平平，第三周却靠自来水观众冲上讨论榜首。一部没有顶流阵容的剧集，凭什么完成口碑反转？",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20portrait%20of%20vintage%20film%20reels%20and%20clapperboard%20on%20terracotta%20background%2C%20soft%20studio%20lighting%2C%20minimal%20clean%20composition%2C%20high%20detail%20product%20photography&width=900&height=600&seq=chigua-drama-01&orientation=landscape",
    date: "2026-09-11",
    heat: 98.6,
    trend: "up",
    readTime: "6 分钟",
    author: "瓜田守望者",
    tags: ["剧集", "口碑逆袭", "暑期档", "长尾效应"],
    highlights: [
      "开播三日播放曲线平平，靠观众自发安利后程发力",
      "剧本扎实与群像塑造被认为是逆转的关键",
      "平台调整推荐策略，二次曝光带来长尾流量",
    ],
    timeline: [
      { time: "第 1 周", text: "首播口碑两极，讨论集中在演员阵容与节奏问题" },
      { time: "第 2 周", text: "关键剧情节点播出，二创视频数量明显上升" },
      { time: "第 3 周", text: "自来水观众带动讨论量登顶，播放量快速爬升" },
      { time: "第 4 周", text: "平台加推推荐位，长尾效应延续至收官" },
    ],
    body: [
      "播出前并不被看好的《长夜灯火》，在收官前完成了一次教科书式的口碑反转。首周它的讨论度在中游徘徊，很多观众甚至没有注意到这部剧已经上线。",
      "转折点出现在第二周的关键剧情播出之后。剧中三条人物线开始交汇，此前被认为「节奏偏慢」的叙事忽然显出结构感，二创视频的数量在一周内翻了几倍。",
      "与传统大制作不同，这部剧没有依赖顶流阵容，而是把预算压在剧本打磨与群像塑造上。观众在讨论区反复提到的一点是：人物动机可信，很少出现为推进剧情而牺牲逻辑的桥段。",
      "从传播路径看，这次逆袭并非偶然。平台在监测到完播率抬升后调整了推荐策略，二次曝光为主创带来了第二轮流量，最终形成了「观众安利 — 数据反馈 — 平台加推」的正向循环。",
    ],
  },
  {
    id: 2,
    slug: "variety-show-golden-cut",
    title: "一档慢综艺的「神剪辑」上热搜，观众到底在争议什么",
    category: "综艺观察",
    categoryId: "variety",
    summary:
      "同一段素材被剪出了完全不同的情绪走向，观众质疑的不是节目本身，而是叙事被过度引导。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20of%20studio%20control%20room%20monitors%20in%20amber%20tones%2C%20soft%20light%2C%20abstract%20minimal%20composition%2C%20high%20detail%2C%20magazine%20photography&width=900&height=600&seq=chigua-variety-01&orientation=landscape",
    date: "2026-09-10",
    heat: 95.2,
    trend: "up",
    readTime: "5 分钟",
    author: "剪辑观察室",
    tags: ["综艺", "剪辑", "慢综艺", "舆论"],
    highlights: [
      "花絮片段显示被剪掉的中立内容，情绪被重新导向",
      "慢综艺依赖情绪张力，剪辑尺度更受关注",
      "观众开始主动对比正片与花絮的差异",
    ],
    timeline: [
      { time: "播出当晚", text: "正片中一段冲突画面登上热搜前列" },
      { time: "次日", text: "会员花絮流出，同一场景呈现不同顺序" },
      { time: "第三天", text: "剪辑话题持续发酵，讨论延伸到行业惯例" },
    ],
    body: [
      "这一期的争议并不在于嘉宾发生了什么，而在于观众发现自己看到的故事，可能与现场真实发生的顺序并不一致。",
      "会员花絮流出后，很多观众做起了对照：正片中被放大的情绪落点，在花絮里前后还连着几段相对平和的对话，而这些内容并没有出现在正片中。",
      "慢综艺的核心卖点就是情绪张力和生活感，这也让剪辑的分寸更容易被放大审视。有从业者在社交平台解释说，成片受时长限制必须做取舍，但观众的反问很直接：取舍和重新编故事，是两回事。",
      "争议的另一面是积极信号——观众不再只是被动接受叙事，而是会主动对比、追问、讨论。这对内容行业来说，其实是一次难得的公开反馈。",
    ],
  },
  {
    id: 3,
    slug: "music-festival-lineup",
    title: "音乐节阵容官宣引发抢票潮，年轻人为何愿意为现场买单",
    category: "音乐现场",
    categoryId: "music",
    summary:
      "一份阵容名单在开票前就带来大量讨论。线下演出持续回暖的背后，是年轻人对真实感的强烈需求。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20toned%20outdoor%20music%20festival%20stage%20at%20golden%20hour%2C%20crowd%20silhouettes%2C%20orange%20and%20rose%20gradient%20sky%2C%20cinematic%20minimal%20composition%2C%20high%20detail&width=900&height=600&seq=chigua-music-01&orientation=landscape",
    date: "2026-09-09",
    heat: 93.8,
    trend: "up",
    readTime: "5 分钟",
    author: "现场记录员",
    tags: ["音乐节", "抢票", "线下演出", "青年文化"],
    highlights: [
      "阵容官宣当日相关话题讨论量快速攀升",
      "观众更看重现场氛围与同行体验，而非单一歌手",
      "周边交通与住宿成为抢票之外的关注点",
    ],
    timeline: [
      { time: "官宣日", text: "阵容公布，话题在两小时内冲上讨论榜" },
      { time: "开票日", text: "首批门票快速售出，观众转向二手平台讨论" },
      { time: "临近演出", text: "交通住宿攻略内容需求明显上升" },
    ],
    body: [
      "一份阵容名单就足以让讨论区沸腾很久，这在几年前还不太常见。如今音乐节的号召力，已经不完全取决于某一位歌手，而是整套现场体验。",
      "从观众反馈看，大家在意的不只是听到哪几首歌，还包括舞台设计、灯效、场地动线，以及和谁一起去。线下演出提供的是一种线上无法复制的共同在场感。",
      "抢票之外，交通与住宿成了新的关注焦点。临近演出时，围绕接驳、周边民宿和观演攻略的内容需求会明显上升，也带动了目的地周边的短期消费。",
      "值得注意的是，越来越多观众开始理性安排预算，把有限的门票机会投给真正想看的场次。这种「精挑细选」的消费方式，正在改变演出市场的运营节奏。",
    ],
  },
  {
    id: 4,
    slug: "box-office-dark-horse",
    title: "小成本电影票房破十亿，口碑发酵的传播路径拆解",
    category: "电影快报",
    categoryId: "movie",
    summary:
      "没有大场面，没有超级卡司，它靠一个真诚的故事跑出了长线曲线。我们复盘了它的三次关键转折。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20cinema%20hall%20with%20red%20seats%20and%20amber%20lighting%2C%20empty%20rows%2C%20minimal%20symmetrical%20composition%2C%20high%20detail%20magazine%20photography&width=900&height=600&seq=chigua-movie-01&orientation=landscape",
    date: "2026-09-08",
    heat: 92.4,
    trend: "up",
    readTime: "7 分钟",
    author: "票房前线",
    tags: ["电影", "票房", "口碑", "黑马"],
    highlights: [
      "首日排片占比不高，靠上座率赢得增量场次",
      "情绪共鸣型内容更容易触发自发安利",
      "社交平台的长评与短视频形成互补传播",
    ],
    timeline: [
      { time: "上映首日", text: "排片占比有限，但单场上座率位居前列" },
      { time: "首周周末", text: "上座率带动影院增加场次，票房曲线抬升" },
      { time: "次周", text: "长评与二创持续产出，长尾表现稳定" },
    ],
    body: [
      "它的开局并不惊艳。首日排片占比不高，宣发声量也谈不上铺天盖地，但影院经理很快发现了一件事：它的单场上座率明显高于同档期影片。",
      "在院线逻辑里，上座率是最直接的信号。周末到来前，不少影院主动增加了它的场次，票房曲线随之出现第一次明显抬升。",
      "真正让曲线延续的，是社交平台上的长评与短视频。前者负责把故事讲清楚，后者负责把情绪传递出去，两者形成了互补的传播结构，让影片在次周依然保持稳定产出。",
      "复盘这部影片的路径，会发现它验证了一个朴素结论：当内容本身能引发真实共鸣时，观众愿意主动成为传播者。这比任何铺量的投放都更持久。",
    ],
  },
  {
    id: 5,
    slug: "celebrity-wedding-look",
    title: "婚礼造型刷屏背后：一份高定礼服的「出圈」逻辑",
    category: "星光时尚",
    categoryId: "fashion",
    summary:
      "一次公开亮相的造型能在几分钟内被拆解到每一处细节。时尚话题的传播，早已不只是美不美的问题。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20ivory%20evening%20gown%20draped%20on%20mannequin%20in%20warm%20beige%20studio%2C%20soft%20directional%20light%2C%20minimal%20luxury%20editorial%20composition%2C%20high%20detail&width=900&height=600&seq=chigua-fashion-01&orientation=landscape",
    date: "2026-09-07",
    heat: 90.1,
    trend: "flat",
    readTime: "4 分钟",
    author: "造型放大镜",
    tags: ["时尚", "造型", "高定", "红毯"],
    highlights: [
      "造型物料在发布后短时间内被大量二次解读",
      "廓形与配色成为被讨论最多的两个维度",
      "低调质感正在取代高饱和度的堆砌式设计",
    ],
    timeline: [
      { time: "当天上午", text: "官方发布造型物料，转发量快速上升" },
      { time: "当天下午", text: "时尚账号开始逐帧拆解材质与廓形" },
      { time: "次日", text: "同款风格搜索量出现明显增长" },
    ],
    body: [
      "造型物料发布后的几个小时，是最热闹的时段。时尚账号会逐帧拆解，从面料垂坠感到配饰比例，一处细节都不放过。",
      "这一轮讨论里，被提到最多的两个维度是廓形与配色。比起高饱和度的堆砌，越来越多造型选择用克制的配色和干净的剪裁说话。",
      "这种审美转向其实早有端倪。过去两年，低调质感在多个公开场合反复出现，观众也慢慢形成了一种共识：高级感来自取舍，而不是叠加。",
      "当一个造型能带动同款风格搜索量上涨，它就完成了从个人亮相到公共话题的转变。这也是时尚内容持续受到关注的原因。",
    ],
  },
  {
    id: 6,
    slug: "reality-show-elimination",
    title: "选秀淘汰结果引爆讨论，赛制公平性再度被摆上台面",
    category: "全网热议",
    categoryId: "buzz",
    summary:
      "一次淘汰让讨论区彻底炸开。观众的疑问很集中：票数计算、赛制权重与信息透明度，是否经得起推敲。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stage%20spotlight%20beam%20on%20dark%20warm%20brown%20stage%20with%20orange%20glow%2C%20minimal%20dramatic%20composition%2C%20high%20detail%20editorial%20photography&width=900&height=600&seq=chigua-buzz-01&orientation=landscape",
    date: "2026-09-06",
    heat: 89.5,
    trend: "down",
    readTime: "5 分钟",
    author: "赛制观察员",
    tags: ["选秀", "赛制", "公平性", "舆论"],
    highlights: [
      "讨论集中在赛制权重与票数规则的解释是否清晰",
      "观众呼吁公开更完整的计票说明",
      "节目组回应将补充规则说明，舆情逐步回落",
    ],
    timeline: [
      { time: "播后 1 小时", text: "淘汰结果公布，讨论区出现大量质疑" },
      { time: "当晚", text: "话题进入热搜前列，理性分析内容开始出现" },
      { time: "次日", text: "节目组补充说明规则，舆论热度逐步回落" },
    ],
    body: [
      "淘汰结果出现的那一刻，讨论区几乎是瞬间被填满的。观众的疑问很集中：如果赛制的权重设计会直接影响结果，那观众是否被充分告知了规则。",
      "在后续的讨论里，情绪逐渐让位于分析。有观众整理出往期数据，试图还原票数计算的逻辑，也有人指出信息透明度才是争议的核心。",
      "节目组在次日补充了规则说明，明确了各项权重与计票方式。随着信息补齐，原本激烈的争论逐步转向对赛制优化的建议。",
      "对综艺来说，赛制既是玩法也是契约。规则越清晰，观众的参与感越强；一旦解释缺位，哪怕是合理的安排也会被怀疑。",
    ],
  },
  {
    id: 7,
    slug: "ancient-costume-upgrade",
    title: "古装剧服化道集体升级，观众审美正在发生什么变化",
    category: "剧集风云",
    categoryId: "drama",
    summary:
      "从服饰纹样到建筑置景，近两年古装剧的制作水准肉眼可见地抬高了，这背后是观众用脚投票的结果。",
    cover:
      "https://readdy.ai/api/search-image?query=traditional%20chinese%20silk%20embroidery%20detail%20in%20warm%20rust%20and%20gold%20tones%2C%20soft%20studio%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail%20craft%20photography&width=900&height=600&seq=chigua-drama-02&orientation=landscape",
    date: "2026-09-05",
    heat: 87.3,
    trend: "up",
    readTime: "6 分钟",
    author: "剧集剖面",
    tags: ["古装剧", "服化道", "审美", "制作"],
    highlights: [
      "观众对细节的敏感度提升，穿帮与考据成为讨论重点",
      "制作方加大置景与服饰投入，追求整体质感统一",
      "审美升级倒逼行业从「流量导向」转向「品质导向」",
    ],
    timeline: [
      { time: "两年前", text: "服化道粗糙成为古装剧被吐槽的高频词" },
      { time: "近一年", text: "多部作品以细节考据获得观众认可" },
      { time: "当下", text: "制作水准成为剧集口碑的重要组成部分" },
    ],
    body: [
      "如果说过去观众看古装剧更在意演员和剧情，那么现在，服饰纹样、建筑置景甚至道具材质，都可能成为决定口碑的关键。",
      "这种变化直接反映在制作端。越来越多剧组把预算投入到服化道与美术置景上，追求整体视觉语言的统一，而不是单点上的华丽堆砌。",
      "观众的敏感度也在同步提升。一处不符合时代的细节，往往会迅速被指出并放大讨论，这反过来又推动制作方更加严谨。",
      "审美升级最终会传导到行业逻辑上：当品质成为观众愿意为之停留的理由，内容生产的天平自然会从流量导向转向品质导向。",
    ],
  },
  {
    id: 8,
    slug: "talk-show-quotes",
    title: "脱口秀金句刷屏，年轻人用幽默消化生活压力",
    category: "综艺观察",
    categoryId: "variety",
    summary:
      "一段关于职场与生活的段子被反复转发。幽默之所以能击中人，是因为它说出了很多人没好意思说的话。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20minimal%20microphone%20on%20wooden%20stool%20with%20amber%20spotlight%20in%20small%20comedy%20club%2C%20soft%20shadows%2C%20editorial%20composition%2C%20high%20detail&width=900&height=600&seq=chigua-variety-02&orientation=landscape",
    date: "2026-09-04",
    heat: 85.9,
    trend: "up",
    readTime: "4 分钟",
    author: "段子研究所",
    tags: ["脱口秀", "金句", "青年文化", "共鸣"],
    highlights: [
      "段子内容紧贴职场与日常，容易引发二次转发",
      "观众用转发与模仿完成情绪表达",
      "喜剧内容的共鸣点正从猎奇转向真实体验",
    ],
    timeline: [
      { time: "播出当晚", text: "数个段子被截图转发，形成金句传播" },
      { time: "次日", text: "相关话题持续升温，出现大量模仿创作" },
      { time: "一周内", text: "讨论延伸到职场压力与生活方式话题" },
    ],
    body: [
      "一段两分钟的段子，能在几个小时内被转发到几乎所有的聊天群里。它受欢迎的原因并不复杂：说出了很多人没好意思说出口的日常。",
      "这一轮出圈的段子，把矛头精准地对准了职场沟通、通勤和社交压力。观众在笑过之后，往往会补上一句「这不就是我吗」。",
      "喜剧的共鸣点正在悄悄变化。过去猎奇式的段子能带来一时的笑声，而如今更能留下来的是那些源于真实生活体验的表达。",
      "用幽默消化压力，是年轻人很擅长的一件事。它既是一种情绪出口，也是一种温和的自我和解方式。",
    ],
  },
  {
    id: 9,
    slug: "concert-ticket-fever",
    title: "演唱会门票秒罄，二级市场溢价现象该不该管",
    category: "音乐现场",
    categoryId: "music",
    summary:
      "开票即售罄早已不是新闻，真正让讨论升温的，是溢价转卖与实名规则的博弈。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20amber%20concert%20crowd%20with%20glowing%20light%20sticks%2C%20soft%20bokeh%20at%20night%2C%20abstract%20minimal%20composition%2C%20high%20detail%20cinematic&width=900&height=600&seq=chigua-music-02&orientation=landscape",
    date: "2026-09-03",
    heat: 84.2,
    trend: "flat",
    readTime: "5 分钟",
    author: "现场记录员",
    tags: ["演唱会", "门票", "实名制", "消费"],
    highlights: [
      "开票即售罄成为常态，抢票难度持续上升",
      "实名制与退改规则成为讨论焦点",
      "理性消费与提前规划被更多观众接受",
    ],
    timeline: [
      { time: "开票前", text: "预约人数远超场馆容量，抢票预期升温" },
      { time: "开票当下", text: "门票快速售罄，讨论转向二级市场" },
      { time: "演出前", text: "实名入场与退改规则成为关注重点" },
    ],
    body: [
      "开票即售罄，这些年已经很难再算新闻。真正让讨论持续升温的，是售罄之后发生的事情。",
      "一边是实名制入场规则不断收紧，一边是二级市场的溢价转卖依然活跃，两者之间的博弈构成了当前演出票务最核心的矛盾。",
      "对观众来说，最实际的做法是提前规划：关注官方渠道的开票提醒，看清退改规则，避免为冲动付费。越来越多人开始接受「看不到就等下次」的理性态度。",
      "票务问题的本质，是供需关系与规则设计的叠加。规则的每一次调整，都会在观众体验上留下清晰的痕迹。",
    ],
  },
  {
    id: 10,
    slug: "franchise-sequel-review",
    title: "系列电影续作口碑分化，情怀还能卖多久",
    category: "电影快报",
    categoryId: "movie",
    summary:
      "熟悉的角色回来了，观众的耐心却没有想象中那么多。续作如何平衡情怀与创新，成为绕不开的考题。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20sepia%20toned%20vintage%20film%20projector%20and%20reel%20on%20wooden%20table%2C%20soft%20window%20light%2C%20minimal%20editorial%20composition%2C%20high%20detail&width=900&height=600&seq=chigua-movie-02&orientation=landscape",
    date: "2026-09-02",
    heat: 82.7,
    trend: "down",
    readTime: "6 分钟",
    author: "票房前线",
    tags: ["电影", "续作", "情怀", "口碑"],
    highlights: [
      "情怀牌在首周有效，长线表现取决于内容质量",
      "观众对重复套路的容忍度明显下降",
      "创新与延续之间的平衡成为续作成败关键",
    ],
    timeline: [
      { time: "上映首周", text: "情怀元素带来关注度，票房开局稳健" },
      { time: "次周", text: "口碑分化显现，票房增速放缓" },
      { time: "第三周", text: "讨论集中在续作创新不足的问题上" },
    ],
    body: [
      "熟悉的角色、熟悉的配乐、熟悉的台词，这些元素确实能在第一时间唤起观众的情感记忆，也往往能带来一个不错的开局。",
      "但情怀的有效期正在缩短。当观众发现续作只是把过去的成功套路重新排列组合，耐心很快就会耗尽，口碑也随之出现分化。",
      "续作真正的难点，在于如何在延续世界观的同时提供新的东西。延续得太少，老观众觉得不像；创新得太多，又可能偏离系列的气质。",
      "从近几年的市场反馈看，能够在两者之间找到平衡的作品，往往才能走得更远。情怀可以是敲门砖，但留不住只看内容的观众。",
    ],
  },
  {
    id: 11,
    slug: "red-carpet-fashion-review",
    title: "红毯造型盘点：低调质感取代浮夸堆砌",
    category: "星光时尚",
    categoryId: "fashion",
    summary:
      "这一届红毯的造型普遍克制，剪裁与配色的完成度成为拉开差距的关键。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20beige%20red%20carpet%20detail%20with%20soft%20velvet%20texture%20and%20golden%20light%2C%20minimal%20luxury%20editorial%20composition%2C%20high%20detail&width=900&height=600&seq=chigua-fashion-02&orientation=landscape",
    date: "2026-09-01",
    heat: 80.4,
    trend: "flat",
    readTime: "4 分钟",
    author: "造型放大镜",
    tags: ["红毯", "造型", "剪裁", "时尚"],
    highlights: [
      "整体造型风格转向克制，剪裁成为评判重点",
      "配色趋于低饱和，面料质感被反复提及",
      "配饰选择更加精简，强调比例与整体协调",
    ],
    timeline: [
      { time: "红毯当天", text: "造型图集密集发布，讨论集中在几套高分造型" },
      { time: "次日", text: "时尚媒体发布造型解析与评分" },
      { time: "一周内", text: "同风格穿搭内容需求上升" },
    ],
    body: [
      "今年的红毯有个很明显的趋势：浮夸的堆砌少了，克制的剪裁多了。观众拿起放大镜看的，也不只是「够不够亮」，而是比例是否协调。",
      "配色上，低饱和度的选择明显更受欢迎。面料质感被反复提及，缎面、丝绒和薄纱的层次处理，成为拉开造型差距的关键细节。",
      "配饰方面也在做减法。越来越多人意识到，恰到好处的一件配饰，比满身闪亮更能成全整体造型。",
      "这种审美转向不仅出现在红毯上，也蔓延到了日常穿搭。克制与质感，正在成为更被长期认可的时尚态度。",
    ],
  },
  {
    id: 12,
    slug: "fan-culture-observation",
    title: "粉丝文化新观察：理性追星成为越来越多人的共识",
    category: "全网热议",
    categoryId: "buzz",
    summary:
      "应援正在变得更克制，讨论也在更理性。一个值得关注的信号是，粉丝群体内部开始主动建立规则。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20soft%20abstract%20shapes%20of%20glowing%20lanterns%20in%20amber%20and%20rose%20tones%2C%20minimal%20artistic%20composition%2C%20high%20detail%20editorial&width=900&height=600&seq=chigua-buzz-02&orientation=landscape",
    date: "2026-08-30",
    heat: 78.9,
    trend: "up",
    readTime: "5 分钟",
    author: "舆论观察站",
    tags: ["粉丝文化", "理性追星", "社群", "舆论"],
    highlights: [
      "应援方式趋于克制，公益类活动比例上升",
      "粉丝社群内部自发形成行为规范",
      "理性讨论逐渐成为主流声音",
    ],
    timeline: [
      { time: "近期", text: "多个粉丝社群发布自律公约" },
      { time: "持续", text: "公益应援与作品支持成为主要方式" },
      { time: "趋势", text: "理性追星获得更多认同与讨论" },
    ],
    body: [
      "一个明显的变化是，越来越多粉丝社群开始主动制定行为规范，把「不打扰、不越界」写进自己的公约里。",
      "应援的方式也在悄悄变化。与过去集中式的物料投放相比，公益类活动和作品本身的传播，正在占据更大的比重。",
      "这种转变来自群体内部的自我调整。当讨论环境更理性，参与者也会更愿意为良好氛围出一份力，形成正向的氛围循环。",
      "追星本可以是件轻松的事。当理性成为共识，喜欢一个人这件事，也能更单纯、更长久。",
    ],
  },
];

export const weeklyTop = [
  { rank: 1, slug: "summer-drama-comeback", heat: 98.6, delta: "+3" },
  { rank: 2, slug: "variety-show-golden-cut", heat: 95.2, delta: "+1" },
  { rank: 3, slug: "music-festival-lineup", heat: 93.8, delta: "+5" },
  { rank: 4, slug: "box-office-dark-horse", heat: 92.4, delta: "0" },
  { rank: 5, slug: "celebrity-wedding-look", heat: 90.1, delta: "-2" },
  { rank: 6, slug: "reality-show-elimination", heat: 89.5, delta: "-1" },
  { rank: 7, slug: "ancient-costume-upgrade", heat: 87.3, delta: "+4" },
  { rank: 8, slug: "talk-show-quotes", heat: 85.9, delta: "+2" },
  { rank: 9, slug: "concert-ticket-fever", heat: 84.2, delta: "-3" },
  { rank: 10, slug: "franchise-sequel-review", heat: 82.7, delta: "0" },
];

export const faqs = [
  {
    q: "1每日吃瓜主要提供哪些内容？",
    a: "我们围绕每日吃瓜热门事件、大瓜汇总与本周瓜单三条主线组织内容，涵盖剧集、综艺、电影、音乐现场、时尚星光与全网热议等方向，帮助你在短时间内掌握焦点事件脉络。",
  },
  {
    q: "网站的内容多久更新一次？",
    a: "热门事件板块每天更新，本周瓜单每周固定刷新一次。遇到讨论度快速上升的焦点事件，我们也会及时补充事件进展与脉络梳理。",
  },
  {
    q: "热度指数是怎么计算的？",
    a: "热度指数综合了站内阅读、讨论增量与话题扩散速度等因素，用一个相对直观的数值呈现在同一时间窗口内的关注程度，仅作参考，不代表任何绝对评价。",
  },
  {
    q: "为什么有些事件只有脉络梳理，没有更多细节？",
    a: "我们坚持内容有据可循的原则，对于信息尚不充分或仍在发展中的事件，只梳理已公开的时间线索，避免对未确认的内容进行猜测性描述。",
  },
  {
    q: "可以订阅本周瓜单吗？",
    a: "可以。在首页或关于我们页面留下你的邮箱，我们会在每周瓜单更新后汇总推送，随时可以取消订阅。",
  },
  {
    q: "网站会收录网友的爆料内容吗？",
    a: "不会直接收录未经核实的爆料。我们更关注已经在公开渠道形成讨论、且有清晰时间线的内容，并鼓励大家理性看待网络信息。",
  },
];